import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from '../../services/loader.service';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  imports: [NzSpinModule, CommonModule],
})
export class SpinnerComponent {
  private loaderService: LoaderService = inject(LoaderService);
  public isLoading$: Observable<boolean> = this.loaderService.isLoading$;
}
